import { nameTableColumn, nameTableRows } from './nameTableRso';

export const colorsColumns = [
  { name: nameTableColumn.columnSerialNumber, column: [], color: '#c4d79b' },
  { name: nameTableColumn.columnTariff, column: [], color: '#dfcdf3' },
  { name: nameTableColumn.columnsAddress, column: [], color: '#9dd7d8' },
  { name: nameTableColumn.columnMeterReading, column: [], color: '#fcd5b4' },
  { name: nameTableColumn.columnDate, column: [], color: '#f1ec8f' },
];

export const colorsRows = [
  { name: nameTableRows.headerRow, rows: '', color: '#fec393ff' },
  { name: nameTableRows.firstRow, rows: '', color: '#bde59eff' },
];
